export const SINGLE_ASSET__SET_ASSET = 'SINGLE_ASSET__SET_ASSET';
export const SINGLE_ASSET__CLEAR_STATE = 'SINGLE_ASSET__CLEAR_STATE';
